function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M19 0H5a5 5 0 00-5 5v19h24V5a5 5 0 00-5-5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FF8415",
  d: "M19 2a3 3 0 013 3v17H2V5a3 3 0 013-3h14z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M14 17H7v-2h7zM8.5 7.5l2.5 3.01L14.5 6l4.5 6H5z"
}));

function SvgQImageWOpenResponseCompletedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _ref);
}

export default SvgQImageWOpenResponseCompletedIcon;